/**
 * WhatsApp Status Component
 * 
 * This component displays the current status of the WhatsApp service
 * and bot connection.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import { useTranslations } from '../../context/TranslationsContext';

const WhatsAppStatus = ({ status }) => {
  const { translations } = useTranslations();
  const { state } = useApp();
  const t = translations[state.currentLanguage];

  if (!status) {
    return (
      <div className="whatsapp-status">
        <div className="status-loading">{t.checkingWhatsappStatus}</div>
      </div>
    );
  }

  const isConnected = status.whatsapp?.connected || status.overall?.healthy || status.connected || status.status === 'connected';

  return (
    <div className="whatsapp-status">
      <div className="status-header">
        <h3>{t.whatsappBot}</h3>
        <div className={`status-indicator ${isConnected ? 'connected' : 'disconnected'}`}>
          {isConnected ? t.connected : t.disconnected}
        </div>
      </div>
      
      <div className="status-details">
        <div className="status-item">
          <span className="label">{t.status}:</span>
          <span className="value">{isConnected ? t.connected : t.disconnected}</span>
        </div>
        
        {status.whatsapp?.user && (
          <div className="status-item">
            <span className="label">{t.user}:</span>
            <span className="value">{status.whatsapp.user.name} ({status.whatsapp.user.phone})</span>
          </div>
        )}
        
        {status.overall?.status && (
          <div className="status-item">
            <span className="label">{t.serviceStatus}:</span>
            <span className="value">{status.overall.status}</span>
          </div>
        )}
        
        {status.timestamp && (
          <div className="status-item">
            <span className="label">{t.lastUpdate}:</span>
            <span className="value">{new Date(status.timestamp).toLocaleString('ar-SA')}</span>
          </div>
        )}
        
        {status.error && (
          <div className="status-item error">
            <span className="label">{t.error}:</span>
            <span className="value">{status.error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WhatsAppStatus;
